/* =====================================================================
   COLDFRAME — 안내 페이지 동작 (cf-info.js)
   카페24 pages/html/sub/faqs.html 스크립트 이식 (jQuery 없음)
   - 질문을 누르면 답변 펼침/접기 (여러 개 동시에 열 수 있음)
   - 왼쪽 분류를 누르면 해당 분류로 부드럽게 이동, 스크롤 위치에 따라 분류 표시
   ===================================================================== */
(function () {
  'use strict';

  var HEADER_OFFSET = 220; // 카페24와 같은 값 (헤더 높이 + 여유)

  function setOpen(item, open) {
    var answer = item.querySelector('.faq-answer');
    var button = item.querySelector('.faq-question');
    item.classList.toggle('open', open);
    if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (answer) {
      // 카페24는 최대 500px 로 고정되어 긴 답변이 잘림 → 내용 높이에 맞춤
      answer.style.maxHeight = open ? answer.scrollHeight + 'px' : '';
    }
  }

  function initFaq(root) {
    if (!root || root.dataset.cfInit === '1') return;
    root.dataset.cfInit = '1';

    root.querySelectorAll('.faq-item').forEach(function (item) {
      var button = item.querySelector('.faq-question');
      if (!button) return;
      button.addEventListener('click', function () {
        setOpen(item, !item.classList.contains('open'));
      });
    });

    var navItems = root.querySelectorAll('.faq-nav-item');
    var sections = root.querySelectorAll('.faq-section[id]');

    function activate(id) {
      navItems.forEach(function (nav) {
        nav.classList.toggle('active', nav.getAttribute('data-target') === id);
      });
    }

    navItems.forEach(function (nav) {
      function go() {
        var target = document.getElementById(nav.getAttribute('data-target'));
        if (!target) return;
        activate(target.id);
        var top = target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
      nav.addEventListener('click', go);
      nav.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          go();
        }
      });
    });

    if ('IntersectionObserver' in window && sections.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) activate(entry.target.id);
        });
      }, { root: null, rootMargin: '-30% 0px -70% 0px', threshold: 0 });
      sections.forEach(function (section) {
        observer.observe(section);
      });
    }

    // 창 크기가 바뀌면 열린 답변 높이 다시 계산
    window.addEventListener('resize', function () {
      root.querySelectorAll('.faq-item.open').forEach(function (item) {
        setOpen(item, true);
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-cf-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  // 테마 편집기에서 질문 블록을 선택하면 답변을 펼쳐서 보여줌
  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest ? event.target.closest('.faq-item') : null;
    if (item) setOpen(item, true);
  });
})();
